<template>
	<view class="success">
		<view class="success_box">
			<image src="@/static/icon/ic_success@2x.png" mode="widthFix"></image>
			<text class="a">恭喜兑换成功</text>
			<text class="b">可在个人中心“咖豆订单”中查看</text>
			<view class="success_box_footer">
				<view class="success_box_footer_btn1" @click="go">返回首页</view>
				<view class="success_box_footer_btn2">查看订单</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			go() {
				uni.switchTab({
					url: '/pages/index/index'
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.success {
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: center;
		.success_box {
			display: flex;
			align-items: center;
			flex-direction: column;
			margin-top: 278rpx;
			image {
				width: 136rpx;
				height: 136rpx;
			}
			.a {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-top: 48rpx;
			}
			.b {
				font-size: 26rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				margin-top: 32rpx;
			}
			.success_box_footer {
				display: flex;
				align-items: center;
				margin-top: 80rpx;
				.success_box_footer_btn1 {
					width: 184rpx;
					height: 64rpx;
					line-height: 64rpx;
					text-align: center;
					border-radius: 56rpx;
					border: 2rpx solid #D20A0A;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #D20A0A;
					margin-right: 32rpx;
				}
				.success_box_footer_btn2 {
					width: 184rpx;
					height: 64rpx;
					line-height: 64rpx;
					text-align: center;
					background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
					border-radius: 56rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
		}
	}
</style>